import React from 'react';

import { CreatePhone } from '../components/Admin/createPhone';
import { Footer } from '../components/Footer/footer';
export const CreatePage = () => {
  return (
    <>
      <CreatePhone />
      <Footer />
    </>
  );
};
